// extracted by mini-css-extract-plugin
export default {"GateBody":"suspend_GateBody__iDj7K","InputContainer":"suspend_InputContainer__LFlYc","Input":"suspend_Input__SSh2L"};